import { AuthApi } from 'app/api/common/auth/api';
import { UserApi } from 'app/api/common/user/api';
import { NavigationApi } from 'app/api/common/navigation/api';

export const apiServices = [AuthApi, UserApi, NavigationApi];
